import { render } from "./spinner.vue?vue&type=template&id=653910d6"
const script = {}

import "./spinner.vue?vue&type=style&index=0&id=653910d6&lang=scss"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__